/*
 * @Author: changcheng
 * @LastEditTime: 2023-02-15 15:18:29
 */
import React, { useEffect, FC, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "@/store/actions";
import "./index.less";
import { Modal, Rate, Button, Input, message } from "antd"
const { TextArea } = Input;
interface Props extends DefaultProps {
  open?: boolean;
  submit: (params: any) => any;
  onCancel: () => any
}

const Evaluation: FC<Props> = (props) => {
  const [star, setStar] = useState(1)
  const [text,setText] = useState('')
  function onChange(e:any){
    setText(e.target.value)
  }
  return (
    <Modal width={'300px'} title="我要评价" open={props.open} onCancel={() => { 
        props.onCancel() 
        setStar(0)
      }} footer={null}>
      <div style={{ width: "80%", margin: "0 auto", display: "flex", flexDirection: "column", justifyContent: "center" }}>
        <Rate value={star} className="myStar" onChange={(val) => {
          setStar(val)
        }}></Rate>
        <TextArea style={{marginTop:"20px"}} value={text}  onChange={onChange}  placeholder="请输入评价内容" autoSize={{ minRows: 4, maxRows: 6 }}></TextArea>
        <div style={{ margin: "20px auto 0" }}>
          <Button type="primary" onClick={() => {
            if(!text){
              message.warning("请输入评价内容")
              return 
            }
            props.submit({star,text})
            setStar(0)
            }}>提交</Button>
        </div>
      </div>

    </Modal>
  );
};
export default Evaluation;
